$(function () {
  window.infoSlider = window.infoSlider || [];

  var init = function () {
    $('.info-slider-container').each(function(i) {
      var configuration = {
        speed: 400,
        autoplay: window.isMobile()?false:7000,
        autoplayDisableOnInteraction: false,
        simulateTouch: false,
        loop: true,
        slideClass: 'info-block',
        slidesPerView: 3,
        breakpoints: {
          500: {
            slidesPerView: 1
          },
          1000: {
            slidesPerView: 2
          }
        },
        prevButton: $(this).find('.slider-arrow-prev')[0],
        nextButton: $(this).find('.slider-arrow-next')[0]
      }

      window.infoSlider[i] = $(this).swiper(configuration);

      var upd = function () {
        window.infoSlider[i].update();
        window.infoSlider[i].slideTo();
        window.infoSlider[i].startAutoplay();
      }
      $(window).off('resize',upd);
      if($('#neos-application').length) {
        $(window).one('resize',upd);
      } else {
        $(window).on('resize',upd);
      }

      $(this).on('mouseenter',function () {
        window.infoSlider[i].stopAutoplay();
      })
      $(this).on('mouseleave',function () {
        window.infoSlider[i].startAutoplay();
      })
    })

    window.initInfoBlocks();

    $(window).on('resize',window.initInfoBlocks);

    $(window).trigger('resize');

    setTimeout(function () {
      $(window).trigger('resize');
    },1000);
  }

  if(!$('#neos-application').length) {
    init();
  }
})
